module.exports = __webpack_public_path__ + "static/media/addWhite.2a0e0621.svg";